import React from 'react'
import PropTypes from 'prop-types'
import {
  FormInput,
  Margin,
  Text,
  FormListItem,
  Drawer,
  Form,
  Panel,
  Button,
} from 'shared/components'
import { observer } from 'mobx-react'

import * as styles from './styles'

const ChangePasswordFormComponent = ({
  form,
  onSubmit,
  appConfig,
  isLoading,
}) => {
  return (
    <>
      <FormListItem
        title="Change Password"
        onClick={() => appConfig.toggleDrawer('changePassword')}
      />
      <Drawer
        isActive={appConfig.drawerState === 'changePassword'}
        hideDrawer={() => appConfig.toggleDrawer('')}
      >
        {appConfig.drawerState === 'changePassword' && (
          <Panel
            as={Form}
            form={form}
            onSubmit={onSubmit}
            css={styles.formWrapper}
          >
            <>
              <div>
                <Margin
                  as={Text}
                  right={1}
                  size={18}
                  bold
                  italic
                  bottom={5}
                  block
                >
                  Change Password
                </Margin>
                <Margin tb={1} css={styles.row}>
                  <Text as="label" size={11}>
                    Old Password
                  </Text>
                  <FormInput
                    type="password"
                    name="oldPassword"
                    placeholder="********"
                    css={styles.control}
                  />
                </Margin>
                <Margin tb={1} css={styles.row}>
                  <Text as="label" size={11}>
                    New Password
                  </Text>
                  <FormInput
                    type="password"
                    name="newPassword"
                    placeholder="********"
                    css={styles.control}
                  />
                </Margin>
                <Margin tb={1} css={styles.row}>
                  <Text as="label" size={11}>
                    Confirmation
                  </Text>
                  <FormInput
                    type="password"
                    name="confirmation"
                    placeholder="********"
                    css={styles.control}
                  />
                </Margin>
              </div>
              <Button
                type="submit"
                medium
                css={{ width: '100%' }}
                disabled={isLoading}
                loading={isLoading}
              >
                Change Password
              </Button>
            </>
          </Panel>
        )}
      </Drawer>
    </>
  )
}

ChangePasswordFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
  appConfig: PropTypes.shape(),
  isLoading: PropTypes.bool,
}

export default observer(ChangePasswordFormComponent)
